import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://axibdocfzscahihbytte.supabase.co';
const SUPABASE_KEY = 'sb_publishable_GkYOY9shUwQHUbm7jk7s9w_lHsHsf4g';

// Supabase client — session is automatically persisted in localStorage
// under the key "sb-axibdocfzscahihbytte-auth-token"
export const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

// Helper: map raw Supabase error messages → friendly copy
export function friendlyAuthError(message = '') {
  if (message.includes('Invalid login credentials'))
    return 'Incorrect email or password. Please try again.';
  if (message.includes('already registered') || message.includes('User already registered'))
    return 'An account with this email already exists. Try signing in instead.';
  if (message.includes('Email not confirmed'))
    return 'Please confirm your email address before signing in. Check your inbox.';
  if (message.includes('Password should be at least') || message.includes('password'))
    return 'Password must be at least 6 characters.';
  if (message.includes('Unable to validate email') || message.includes('invalid format'))
    return 'Please enter a valid email address.';
  if (message.includes('signup is disabled') || message.includes('Signups not allowed'))
    return 'New registrations are currently paused. Please try again later.';
  if (message.includes('rate limit') || message.includes('too many'))
    return 'Too many attempts. Please wait a moment and try again.';
  if (message.includes('fetch') || message.includes('network') || message.includes('Failed'))
    return 'Connection error. Check your internet connection and try again.';
  return message;
}
